export default __webpack_public_path__ + "static/media/phone.7496f0c1.svg";